export const ENVIRONMENT =
  process.env.REACT_APP_ENVIRONMENT === "true" ? true : false;

export const currentEnv =
  process.env.REACT_APP_ENVIRONMENT === "true" ? "prd" : "test";

export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;

// url

/** 博客 */
export const CCPAYMENT_BLOG_URL = "https://ccpayment.com/blog/";

/** v1文档 url */
export const V1_API_URL =
  "https://doc.ccpayment.com/ccpayment-for-developer/payment-api-ccpayment";

/** tg机器人客服 联系 url */
export const TELEGRAM_SUPPORT_URL = "https://t.me/CCPaymentSupportBot";

/** Twitter 联系 url */
export const TWITTER_SUPPORT_URL = "https://twitter.com/ccpayment_com";

/** E-mail 联系 url */
export const EMAIL_SUPPORT_URL = "mailto:support@ccpayment.com";

/** 后台注册url */
export const ADMIN_REGISTER_URL = "https://console.ccpayment.com/register";

/** 后台开发者url */
export const ADMIN_DEV_URL = "https://console.ccpayment.com/developer/config";

/** 网站校验url */
export const WEBSITE_URL =
  "https://console.ccpayment.com/merchatsetting/menu/verification/index";

/** 后台商户设置菜单 */
export const ADMIN_MERCHANT_SETTING_URL =
  "https://console.ccpayment.com/merchatsetting/menu/settings";

/** 后台webhook page */
export const ADMIN_WEBHOOK_URL = "https://console.ccpayment.com/webhook/index";

/** 联系ccpayment团队url */
export const CONTACT_CCPAYMENT_TEAM_URL =
  "https://console.ccpayment.com/register";

/** 联系专家url */
export const CONTACT_CCPAYMENT_TECHNICAL_EXPERT_URL =
  "https://console.ccpayment.com/register";

/** ip白名单url */
export const IP_WHITE_LIST_URL = "https://console.ccpayment.com/register";

/** 签名文档 */
export const SIGN_DOC_URL = "https://console.ccpayment.com/register";

/** 获取代币提现网络费url */
export const GET_COIN_WITHDRAW_NETWORK_FEE_URL =
  "https://console.ccpayment.com/register";

/** 查看归集费用详情url */
export const VIEW_COLLECT_FEE_URL =
  "https://console.ccpayment.com/transaction/collect-list";

/** webhook重发接口url */
export const WEBHOOK_RESEND_URL =
  "https://ccpayment.com/ccpayment/v2/webhook/resend";

/** 获取代币列表接口url */
export const GET_COIN_LIST_URL =
  "https://ccpayment.com/ccpayment/v2/getCoinList";

/** 获取代币信息url */
export const GET_COIN_INFO_URL = "https://ccpayment.com/ccpayment/v2/getCoin";

/** 获取代币的USDT价格url */
export const GET_COIN_USDT_PRICE_URL =
  "https://ccpayment.com/ccpayment/v2/getCoinUSDTPrice";

/** 用户列表 */
export const GET_USER_LIST_URL =
  "https://console.ccpayment.com/user-list/index";

//创建区块链提现订单
export const USER_WITHDRAW_TO_NETWORK =
  "https://ccpayment.com/ccpayment/v2/applyUserWithdrawToNetwork";

//提现到cwallet账户
export const USER_WITHDRAW_TO_CWALLET =
  "https://ccpayment.com/ccpayment/v2/applyUserWithdrawToCwallet";

//获取单条提现记录
export const USER_WITHDRAW_TO_RECORD =
  "https://ccpayment.com/ccpayment/v2/getUserWithdrawRecord";

//获取提现记录列表
export const USER_WITHDRAW_TO_RECORD_LIST =
  "https://ccpayment.com/ccpayment/v2/getUserWithdrawRecordList";

//发起商户用户间的及时转账
export const USER_TRANSFER = "https://ccpayment.com/ccpayment/v2/userTransfer";

//获取用户转账记录
export const USER_TRANSFER_RECORD =
  "https://ccpayment.com/ccpayment/v2/getUserTransferRecord";
//获取用户转账历史记录
export const USER_TRANSFER_RECORD_LIST =
  "https://ccpayment.com/ccpayment/v2/getUserTransferRecordList";

//获取商家资产列表
export const APP_COIN_ASSETLIST =
  "https://ccpayment.com/ccpayment/v2/getAppCoinAssetList";

//获取商家指定代币资产
export const APP_COIN_ASSET =
  "https://ccpayment.com/ccpayment/v2/getAppCoinAsset";

//创建订单收款地址
export const CREATE_APP_AORDER_EPOSIT_ADDRESS =
  "https://ccpayment.com/ccpayment/v2/createAppOrderDepositAddress";

//获取指定的充值订单记录
export const APP_ORDERRECORD =
  "https://ccpayment.com/ccpayment/v2/getAppOrderInfo";

//创建或获取永久收款地址
export const CREATE_APP_DEPOSIT__ADDRESS =
  "https://ccpayment.com/ccpayment/v2/getOrCreateAppDepositAddress";

//获取充值记录
export const APP_DEPOSIT__RECORD =
  "https://ccpayment.com/ccpayment/v2/getAppDepositRecord";

//获取充值记录列表
export const APP_DEPOSIT__RECORD_LIST =
  "https://ccpayment.com/ccpayment/v2/getAppDepositRecordList";

//提现到区块链
export const APP_WITHDRAW__TO_NETWORK =
  "https://ccpayment.com/ccpayment/v2/applyAppWithdrawToNetwork";

//创建到Cwallet账户的提现订单
export const APP_WITHDRAW__TO_CWALLET =
  "https://ccpayment.com/ccpayment/v2/applyAppWithdrawToCwallet";

//获取单条提现记录
export const APP_WITHDRAW__RECORD =
  "https://ccpayment.com/ccpayment/v2/getAppWithdrawRecord";

//获取提现记录列表
export const APP_WITHDRAW__RECORD_LIST =
  "https://ccpayment.com/ccpayment/v2/getAppWithdrawRecordList";

//获取法定货币列表
export const FAILT_LIST = "https://ccpayment.com/ccpayment/v2/getFiatList";

//获取代币提现网络费
export const WITHDRAW_FEE = "https://ccpayment.com/ccpayment/v2/getWithdrawFee";

//获取Cwallet用户信息
export const CWALLET_USERID =
  "https://ccpayment.com/ccpayment/v2/getCwalletUserId";

// user wallet model
//用户资产查询
export const USER_COIN_LIST =
  "https://ccpayment.com/ccpayment/v2/getUserCoinAssetList";

//用户代币资产
export const USER_COIN_ = "https://ccpayment.com/ccpayment/v2/getUserCoinAsset";

//创建或获取用户永久收款地址
export const CREATE_USER_DEPOSIT_ADDRESS =
  "https://ccpayment.com/ccpayment/v2/getOrCreateUserDepositAddress";

//获取用户充值记录
export const CREATE_USER_DEPOSIT_RECOED =
  "https://ccpayment.com/ccpayment/v2/getUserDepositRecord";

//获取用户充值历史记录
export const CREATE_USER_DEPOSIT_RECOED_LIST =
  "https://ccpayment.com/ccpayment/v2/getUserDepositRecordList";

// LAYOUT

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
};

export const NAV = {
  W_BASE: 260,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  W_DASHBOARD_NAV_MINI: 66,
  //
  W_DRAWER_FIRST: 400,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
};

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};

export const ICONFOLD = {
  NAV_ITEM: 56,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};
